/**
 * @file  helper.js
 *
 * @author hongyang03
 */

import $ from 'jquery';
import 'jquery.cookie';
import axios from 'axios';
import Link from './link';

export const isOnline = /(market|cloud|qifu)\.baidu\.com/.test(window.location.hostname);

export const originWidth = 750;

export const rateRem = 10;

// 获取UUID
export const getUUID = () => {
    let s = [];
    let hexDigits = '0123456789abcdef';
    for (let i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = '4';
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
    s[8] = s[13] = s[18] = s[23] = '-';
    let uuid = s.join('');
    return uuid;
};

// 加密
export const base64Encode = str => {
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
        function toSolidBytes(match, p1) {
            return String.fromCharCode('0x' + p1);
        }));
};

// 解密
export const base64Decode = str => {
    return decodeURIComponent(atob(str).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
};

// 是否登录
export const isLogin = async () => {
    let options = {
        url: Link.displayName + '/api/account/v2/displayName',
        dataType: 'jsonp',
        timeout: 3000,
        withCredentials: true
    };
    let response = await $.ajax(options);
    const result = response && response.result || {};
    const isLogin = result.hasLogin === true;
    if (isLogin) {
        const host = window.location.hostname;
        const cookies = result.cookies || {};
        const accountId = result.accountId || '';
        $.cookie('accountId', accountId, {path: '/', domain: '.' + host});
        const clientCookies = cookies['bce-ctl-client-cookies']
            ? cookies['bce-ctl-client-cookies'].slice(1, -1).split(',') : [];
        // const sessionId = cookies['bce-sessionid'] || '';
        const bceAuthType = cookies['bce-auth-type'] || '';
        // $.cookie('bce-sessionid', sessionId, {path: '/', domain: '.' + host});
        $.cookie('bce-auth-type', bceAuthType, {path: '/', domain: '.' + host});
        clientCookies.forEach(element => {
            const cookieValue = cookies[element] || '';
            $.cookie(element, cookieValue, {path: '/', domain: '.' + host});
        });
    }
    return Promise.resolve(response);
};

// 移动端 Header
export function addMobileHeader() {
    let scriptNode = document.createElement('script');
    scriptNode.setAttribute('src', Link.mobileHeaderScriptSrc);
    scriptNode.onload = () => {
        if (window.portalCommon) {
            window.portalCommon.setup({
                showHeader: true,
                showPcFooter: false
            });
        }
    };
    document.head.appendChild(scriptNode);
}

// 跳转到登录界面
export function skipToLoginPage() {
    window.open(Link.login, '_self');
}

// 获取 cookie
export function getCookie(name, cookieText = '') {
    if (isBrowser()) {
        cookieText = document.cookie;
    }

    const reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
    const arr = cookieText.match(reg);

    let ret = '';

    if (arr) {
        ret = decodeURIComponent(arr[2]);
    }

    return ret;
}

// 封装 axios
export function initAxios(config) {
    const instance = axios.create({
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            csrfToken: getCookie('bce-user-info').replace(/"/g, '') // 获取cookie中的bce-user-info
        },
        ...config
    });
    instance.interceptors.response.use((response) => {
        if (!response.data.success || response.data.success === 'false') {
        return Promise.reject(response.data.message);
        }
        return response && response.data && response.data.result;
    }, (error) => {
        return Promise.reject(error);
    });
    return instance;
}

export function resetRem() {
    const clientWidth = document.documentElement.clientWidth;
    const htmlDom = document.querySelector('html');
    htmlDom.style.fontSize = clientWidth * rateRem / originWidth + 'px';
}

export function isBrowser() {
    return (typeof window !== 'undefined' || typeof document !== 'undefined');
}

export function isMobile(ctx) {
    const deviceAgent = isBrowser()
        ? navigator.userAgent
        : (ctx && ctx.headers['user-agent']);
    return deviceAgent && deviceAgent.toLowerCase().match(/(iphone|ipod|ipad|android|symbianos|windows phone)/);
}

// 将参数转换为数组
export function convertParamArrToObj(arr, obj) {
    obj = obj || {};
    for (let i = 0; i < arr.length; i++) {
        const tempArr = arr[i].split('=');
        obj[tempArr[0]] = tempArr[1];
    }
    return obj;
}

// 根据当前所在界面返回默认的追踪字段值
export function getDefaultTrackValueByPage() {
    let {hash, pathname} = window.location;
    const page = pathname.includes('crs') ? 'crs_detail' : 'bkp_detail';
    if (!hash) {
        return 'cbs_portal_index';
    }
    // 去除 #/
    hash = hash.replace(/^#\//, '');
    // 替换为下划线分隔
    hash = hash.replace(/\//, '_');
    return `cbs_portal_${hash || page}`;
}

// 获取URL中携带的参数
export function getTrackValueFromUrl(name) {
    const trackKeys = ['trace', 'track', 'pageResource', 'pageSource'];
    let obj = {};
    // 从 search 中获取参数
    const search = window.location.search.substring(1);
    const searchParamArr = search.split('&');
    obj = convertParamArrToObj(searchParamArr, obj);

     // 从 hash 中获取参数
    const hashQueryIndex = window.location.hash.indexOf('?');
    const hashQuery = window.location.hash.substring(hashQueryIndex + 1);
    const hashParamArr = hashQuery.split('&');

    // 按照优先级，返回 url 链接中的追踪参数的字段值
    obj = convertParamArrToObj(hashParamArr, obj);
    for (let i = 0; i < trackKeys.length; i++) {
        const key = trackKeys[i];
        if (obj[key]) {
            return decodeURIComponent(obj[key]);
        }
    }

    // 如果传入的 name 有值，则返回 name
    if (typeof(name) === 'string' && name) {
        return name;
    }

    return getDefaultTrackValueByPage();
}
export function checkTwo() {
    const sUserAgent = navigator.userAgent.toLowerCase();
    // 判断是否在手百内，手百内需要进行二次验证
    if (sUserAgent.indexOf('baiduboxapp') > -1) {
        isLogin().then(res => {
            if (res && res.result && res.result.hasLogin) {
                const http = initAxios({
                    baseURL: Link.host,
                    withCredentials: true
                });
                // msf验证地址
                const checkUrl = `${Link.host}/iam/access?redirect=${encodeURIComponent(window.location.href)}`;
                http.post('/api/iam/securityinfo').then(res => {
                    if (res && res.redirect) {
                        window.location.href = checkUrl;
                    }
                }).catch(err => {
                    if (err && err.redirect) {
                        window.location.href = checkUrl;
                    }
                });
            }
        });
    }
}
